module.exports = __webpack_public_path__ + "static/media/m120-44.089b9073.png";